import React, {useState, useEffect} from 'react';
import DownloadsFilter from "../components/DownloadsFilter";
import DownloadsList from "../components/DownloadsList";
import {getAllDownloads} from "../service/api";
import {DownloadItem} from "../types/downloadItem";
import {FilterTags} from "../types/filterTags";
import {FilterDemand} from "../types/filterDemand";

type DownloadsFilterProps = {
    filterTags : FilterTags[]
    singleTag : string
}

const INITIAL_LIMIT = 15;

export enum AppState { initializing, loading, ready}

function Downloads({filterTags, singleTag} : DownloadsFilterProps) {

    const [downloads, setDownloads] = useState<DownloadItem[]>([]);
    const [demand, setDemand] = useState<FilterDemand>({...initialDemand, tags: singleTag});
    const [remainingDownloads, setRemainingDownloads] = useState<boolean>(true);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [appState, setAppState] = useState<AppState>(AppState.ready);

    useEffect(() => {
        setAppState(AppState.loading);
        getAllDownloads(demand).then(response => {
            setDownloads(response.data);
            setRemainingDownloads(response.remaining);
            setAppState(AppState.ready);
        });
    }, [demand]);

    const loadMore = () => {
        const newDemand = {
            ...demand,
            limit: demand.limit + INITIAL_LIMIT,
        };
        setDemand(newDemand);
    };

    return (
        <div className='downloadsOverview container'>
            <DownloadsFilter
                demand={demand}
                setDemand={setDemand}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                filterTags={filterTags}
                singleTag={singleTag}
            />

            <DownloadsList
                downloads={downloads}
                appState={appState}
                loadMore={loadMore}
                moreAvailable={remainingDownloads}
            />
        </div>
    );
}

const initialDemand : FilterDemand = {
    tags: '',
    option1: 0,
    option2: 0,
    limit: 15,
    term: ''
};

export default Downloads;
